var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('response-viewer',{staticClass:"fill-container",attrs:{"form-response":_vm.formResponse},on:{"sendMessage":_vm.sendMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }